module.exports = __webpack_public_path__ + "static/media/GameGalleryBg-sm.aaadfb9f.jpg";